var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8751 24C20.5543 24 20.2351 23.9085 19.9603 23.7263L13.5002 19.4219L7.04004 23.7263C6.48971 24.0922 5.75119 24.0922 5.20404 23.7204C4.65689 23.3522 4.4266 22.6985 4.63148 22.1016L7.04083 14.8771L0.638662 10.6856C0.0946923 10.313 -0.131631 9.65784 0.0764275 9.06022C0.286074 8.46408 0.88325 8.05902 1.55825 8.0546L9.4875 8.04353L12.012 0.998247C12.2248 0.401365 12.8244 0 13.5002 0C14.176 0 14.7755 0.402103 14.9891 0.998247L17.4708 8.04353L25.4405 8.0546C26.1179 8.05902 26.7159 8.46482 26.9231 9.06022C27.132 9.65784 26.9057 10.313 26.3609 10.6856L19.9587 14.8771L22.3681 22.1016C22.5745 22.6985 22.3419 23.3522 21.7963 23.7204C21.5208 23.9078 21.1983 24 20.8751 24Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGrey);
export default __webpack_public_path__ + "static/media/starGrey.8b36c1f1aada55986d04aa1ebee5c84d.svg";
export { ForwardRef as ReactComponent };